import { render, staticRenderFns } from "./FbIdInputV2.vue?vue&type=template&id=70f06cfa&scoped=true"
import script from "./FbIdInputV2.vue?vue&type=script&lang=js"
export * from "./FbIdInputV2.vue?vue&type=script&lang=js"
import style0 from "./FbIdInputV2.vue?vue&type=style&index=0&id=70f06cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f06cfa",
  null
  
)

export default component.exports